// extracted by mini-css-extract-plugin
export var completionBody = "_ks-2";
export var completionCard = "_ks-0";
export var completionFooter = "_ks-3";
export var completionTitle = "_ks-1";